import React, {Component} from 'react'
import {findDOMNode} from 'react-dom'
import {style, media, merge, after} from 'glamor'
import * as colors from '../../colors'
import {ButtonCircle} from 'rebass'
import {Arrow} from 'reline'
import Label from '../Label'
import Thumb from '../ThumbProject'
import {Link, Match} from 'react-router'
import ProjectList from '../ProjectList'
import Project from './Project'
import { Scrollbars } from 'react-custom-scrollbars'
import AutoSizer from '../AutoSizer'
import find from 'lodash.find'


export default class extends Component {

  render(){

    return (
      <div
        {...style({
          width: '100%',
          height: '100%',
        })}
      >
      <AutoSizer>
      { ({width, height}) => (
        <Scrollbars
          ref='content'
          autoHide={true}
          renderTrackVertical={ props => (
            <div
              {...props}
              {...style({
                right: 0,
                width: 10,
                height: '100%'
              })}
            />
          )}
          renderThumbVertical={ props => (
            <div
              {...props}
              {...style({
                background: colors.yellow,
                width: 10,
                height: '100%'
              })}
            />
          )}
          onScroll={(evt)=>evt.stopPropagation()}
          style={{ width: width, height: height }}
        >

              <Project
                {...this.props}
              />

        </Scrollbars>
      )}</AutoSizer>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/pages/ProjectDesktop.js
 **/